import React from 'react';
import {observer} from 'mobx-react';
import ReactDOM from "react-dom";

import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {TooltipArrowBox} from "./boxes/tooltip-arrow/tooltip-arrow.box";
import {TooltipContentBox} from "./boxes/tooltip-content.box";
import {TooltipCloseButtonBox} from "./boxes/tooltip-close-button.box";
import {TooltipContainerBox} from "./boxes/tooltip-container/tooltip-container.box";
import {CyClass} from "../../../common/cy-classes";

@observer
export class ToolTipContainerComponent extends OrbitComponent {
    render() {
        const toolTipService = this.services.tooltip;
        const currentTooltip = toolTipService.currentToolTip;
        const {content = null, close: closeTooltip, options} = currentTooltip || {};

        return ReactDOM.createPortal(
            <TooltipContainerBox
                className={`tooltip-container ${CyClass('cy-tooltip-container')}`}
                ref={toolTipService.setTooltipContainer}
                active={!!currentTooltip}
                {...options?.styling}>

                {options?.showCloseButton && <TooltipCloseButtonBox onClick={closeTooltip} invertColors={options?.invertCloseButtonColors}/>}

                <TooltipContentBox>
                    {content}
                </TooltipContentBox>

                <TooltipArrowBox
                    id="tool-tip-container-arrow"
                    data-popper-arrow=""
                    {...options?.styling}
                />
            </TooltipContainerBox>
            , this.services.dom.body);
    }
}